import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import BCBADashboard from './BCBADashboard';
import GeneralDashboard from './GeneralDashboard';
import { areUserRolesIn } from '../../helpers';
import { Roles } from '../../constants';

import type { RootState } from '../../store';

function Dashboard() {
  const { user } = useSelector((state: RootState) => state.auth);

  const isBCBA = useMemo(() => {
    return areUserRolesIn(user?.roles, [Roles.Bcba]);
  }, [user]);

  const Dashboard = isBCBA ? BCBADashboard : GeneralDashboard;

  return <Dashboard />;
}

export default Dashboard;
